<template>
  <Content stretch>
    <slot>no trails component specified</slot>
  </Content>
</template>

<script>
import { Content } from '@neurotrack/web-shared-components'
import essExamProps from '@/mixins/essExamProps'

export default {
  name: 'exam_trails',
  components: { Content },
  mixins: [essExamProps],
  watch: {
    isExamComplete(complete) {
      if (complete && !this.isPractice) {
        this.completeExam()
      }
    }
  },
  methods: {
    completeExam() {
      this.$store.dispatch(`exam/${this.exam}/complete`, undefined, {
        root: true
      })
    },
    trackEvent(perception) {
      this.$store.dispatch(`exam/${this.exam}/trackEvent`, perception, {
        root: true
      })
    },
    /**
     * @param {Object} root
     * @param {Object} root.event
     */
    handleResponse({ event }) {
      this.trackEvent(event)
      this.$emit('next')
    }
  }
}
</script>

<style scoped></style>
